//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '3.8.5'.
//
package graphql

import com.apollographql.apollo3.annotations.ApolloAdaptableWith
import com.apollographql.apollo3.api.Adapter
import com.apollographql.apollo3.api.CompiledField
import com.apollographql.apollo3.api.CustomScalarAdapters
import com.apollographql.apollo3.api.Query
import com.apollographql.apollo3.api.json.JsonWriter
import com.apollographql.apollo3.api.obj
import graphql.adapter.GetTradeNewsItemQuery_ResponseAdapter
import graphql.adapter.GetTradeNewsItemQuery_VariablesAdapter
import graphql.selections.GetTradeNewsItemQuerySelections
import kotlin.String
import kotlin.Unit

public data class GetTradeNewsItemQuery(
  public val id: String,
) : Query<GetTradeNewsItemQuery.Data> {
  public override fun id(): String = OPERATION_ID

  public override fun document(): String = OPERATION_DOCUMENT

  public override fun name(): String = OPERATION_NAME

  public override fun serializeVariables(writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters): Unit {
    GetTradeNewsItemQuery_VariablesAdapter.toJson(writer, customScalarAdapters, this)
  }

  public override fun adapter(): Adapter<Data> = GetTradeNewsItemQuery_ResponseAdapter.Data.obj()

  public override fun rootField(): CompiledField = CompiledField.Builder(
    name = "data",
    type = graphql.type.Query.type
  )
  .selections(selections = GetTradeNewsItemQuerySelections.__root)
  .build()

  @ApolloAdaptableWith(GetTradeNewsItemQuery_ResponseAdapter.Data::class)
  public data class Data(
    /**
     * IDを指定して単一のトレードニュースを取得します
     */
    public val tradeNewsItem: TradeNewsItem?,
  ) : Query.Data

  public data class TradeNewsItem(
    /**
     * ニュースの一意識別子
     */
    public val id: String,
    /**
     * ニュースのタイトル
     */
    public val title: String,
    /**
     * ニュースの説明文
     */
    public val description: String?,
    /**
     * ニュースへのリンク
     */
    public val link: String,
    /**
     * ニュースソース（ESPN、RealGMなど）
     */
    public val source: String,
    /**
     * 公開日時
     */
    public val publishedAt: String,
    /**
     * カテゴリー（Trade、Signing、Other）
     */
    public val category: String,
    /**
     * 日本語タイトル
     */
    public val titleJa: String?,
    /**
     * 日本語説明文
     */
    public val descriptionJa: String?,
    /**
     * 翻訳ステータス
     */
    public val translationStatus: String,
    /**
     * 翻訳日時
     */
    public val translatedAt: String?,
    /**
     * AI日本語要約（記事本文ベース）
     */
    public val summaryJa: String?,
    /**
     * 要約ステータス（pending / completed / failed）
     */
    public val summaryStatus: String,
    /**
     * 要約生成日時
     */
    public val summarizedAt: String?,
  )

  public companion object {
    public const val OPERATION_ID: String =
        "ab15930be4f9bf5332d6a72861547cd45df3eff2b95b37a7b793800a31f0d337"

    /**
     * The minimized GraphQL document being sent to the server to save a few bytes.
     * The un-minimized version is:
     *
     * query GetTradeNewsItem($id: String!) {
     *   tradeNewsItem(id: $id) {
     *     id
     *     title
     *     description
     *     link
     *     source
     *     publishedAt
     *     category
     *     titleJa
     *     descriptionJa
     *     translationStatus
     *     translatedAt
     *     summaryJa
     *     summaryStatus
     *     summarizedAt
     *   }
     * }
     */
    public val OPERATION_DOCUMENT: String
      get() =
          "query GetTradeNewsItem(${'$'}id: String!) { tradeNewsItem(id: ${'$'}id) { id title description link source publishedAt category titleJa descriptionJa translationStatus translatedAt summaryJa summaryStatus summarizedAt } }"

    public const val OPERATION_NAME: String = "GetTradeNewsItem"
  }
}
